import initialState from './BranchInitialState';
import reducers from './BranchReducer';

export default {
  initialState,
  reducers,
};
